export default function isZoomArea(area: string, facility?: string) {
  return area === 'Z_Z' || facility === 'ZOOM';
}
